var map = {
	"./en/bulk_download.json": 787,
	"./en/erp.json": 788,
	"./en/global.json": 789,
	"./en/invoice_payments.json": 790,
	"./en/layouts.json": 791,
	"./en/purchase_orders.json": 792,
	"./en/requisition.json": 793,
	"./en/segments.json": 794,
	"./en/settings.json": 795,
	"./es/bulk_download.json": 796,
	"./es/erp.json": 797,
	"./es/global.json": 798,
	"./es/invoice_payments.json": 799,
	"./es/layouts.json": 800,
	"./es/purchase_orders.json": 801,
	"./es/requisition.json": 802,
	"./es/segments.json": 803,
	"./es/settings.json": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;